"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrevious = exports.logState = void 0;

var _react = require("react");

// Don't die on old Edge
if (typeof globalThis === 'undefined') {
  // eslint-disable-next-line no-global-assign
  globalThis = {};
} // noinspection JSUnresolvedVariable
// globalThis._react_js_dbg = true


var logState = function logState(type, opts) {
  if (!opts) {
    return;
  }

  var id = opts.id,
      instance = opts.instance,
      props = opts.props,
      prevProps = opts.prevProps;
  return globalThis._react_js_dbg && console.log("\n    ".concat(type, " on ").concat(id, ", \n    ToC Instance: ").concat(instance, ", \n    prevProps: ").concat(JSON.stringify(prevProps), ", \n    props: ").concat(JSON.stringify(props), "\n    "));
};

exports.logState = logState;

var usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
};

exports.usePrevious = usePrevious;